module.exports = __webpack_public_path__ + "static/img/productimg10.b4a73333.png";